export default "__VITE_ASSET__CsHo4gDr__"